import type { InvoiceLayoutCheck } from "@/hooks/use-invoice-layout-check";

export default function InvoiceLayoutWarnings({ check }: { check?: InvoiceLayoutCheck }) {
  if (!check) return null;
  return (
    <div aria-live="polite" aria-atomic="true" className="text-sm">
      {check.checking ? <p className="text-slate-600">Deckblatt-Layout wird geprüft…</p>
        : check.error ? <p role="alert" className="text-red-800">{check.error}</p>
        : check.report && (check.report.warnings.length ? (
          <div className="rounded-md border border-amber-300 bg-amber-50 p-3 text-amber-950">
            <p className="font-semibold">Bitte Deckblatt-Layout prüfen</p>
            <ul className="mt-2 list-disc space-y-1 pl-5">
              {check.report.warnings.map((warning, index) => <li key={index}>{warning.message}</li>)}
            </ul>
            <p className="mt-2">Ihre Positionen bleiben unverändert. Verschieben Sie die genannten Bereiche bei Bedarf und kontrollieren Sie die PDF-Vorschau.</p>
          </div>
        ) : <p className="text-slate-600">Keine Überschneidungen im gerenderten Deckblatt erkannt.</p>)}
    </div>
  );
}
